import { render } from "./authority-dialog.vue?vue&type=template&id=21e107e0&scoped=true"
import script from "./authority-dialog.vue?vue&type=script&lang=js"
export * from "./authority-dialog.vue?vue&type=script&lang=js"

import "./authority-dialog.vue?vue&type=style&index=0&id=21e107e0&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e107e0"]])

export default __exports__